//PACKS
import React from "react";

//STYLES
import "../styles/hero.scss";

//ASSETS
import logo from "../assets/set_logo.svg";
import heroCover from "../assets/hero_cover.jpg";

export default function Hero() {
  return (
    <>
      <div
        className="heroContainer"
        style={{ backgroundImage: `url(${heroCover})` }}
        id="hero"
      >
        <div className="heroShade" />
        <div className="hero">
          <img className="heroLogo" src={logo} alt="heroLogo" />
          <p>
            SET è una società di Advisory strategica specializzata nel design e
            nell’animazione di filiere, ecosistemi e hub fisici dedicati
            all’innovazione e alla crescita del capitale umano.
          </p>
        </div>
      </div>
      {/* <div className="separator" /> */}
    </>
  );
}
